import React, {
  forwardRef
} from "react";
import { cx } from "@linaria/core";
import { RadioWrapper, HiddenRadio } from "./Radio.styles";
const defaultProps = {
  checked: false,
  className: "",
  label: "",
  value: "",
  testId: "Radio",
  field: {
    value: "",
    name: "",
    onChange: (f) => f,
    onBlur: (f) => f
  }
};
const Radio = forwardRef(({ id, checked, className, label, value, testId, field, disabled, ...rest }, ref) => {
  const { value: selectedValue, name, onChange, onBlur } = field;
  const valueMatchesSelected = !!value && value === selectedValue;
  const isChecked = checked || valueMatchesSelected;
  const handleOnChange = (e) => {
    if (onChange)
      onChange(e);
  };
  const handleBlur = (e) => {
    if (onBlur)
      onBlur(e);
  };
  return /* @__PURE__ */ React.createElement(RadioWrapper, {
    htmlFor: id,
    "data-testid": testId,
    className: cx(disabled && "radio__disabled", className)
  }, /* @__PURE__ */ React.createElement(HiddenRadio, {
    id,
    name,
    type: "radio",
    checked: isChecked,
    value,
    onChange: handleOnChange,
    onBlur: handleBlur,
    ref,
    disabled,
    ...rest
  }), /* @__PURE__ */ React.createElement("div", {
    className: "radio__outline"
  }, isChecked && /* @__PURE__ */ React.createElement("div", {
    className: "radio__dot"
  })), /* @__PURE__ */ React.createElement("span", {
    className: "radio__label"
  }, label));
});
Radio.defaultProps = defaultProps;
export default Radio;
